import PropTypes from 'prop-types';
import { faCheckCircle, faCircleMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import tw from 'tailwind-styled-components';
import { STATUS_DENIED, STATUS_OKAY, STATUS_WAITING } from '../utlities/core.constants';

const StatusContainer = tw.div`mb-6 flex border-0 border-l-8 border-solid ${props => props.status === STATUS_OKAY ? 'border-l-green bg-green-light' : null} ${props => props.status === STATUS_WAITING ? 'border-l-yellow-600 bg-yellow-100' : null} ${props => props.status === STATUS_DENIED ? 'border-l-red-600 bg-red-100' : null}`
export default function StatusBar({status = '', title = '', description = ''}){

  return (
    <StatusContainer status={status}>
      <div className='text-2xl pl-8 pt-5 flex items-baseline'>
        <FontAwesomeIcon icon={status === '' ? faCircleMinus : faCheckCircle} />
      </div>
      <div className="pl-4">
        <div>
          <div className='text-xl font-bold pt-3'>{title}</div>
          <p>{description}</p>
        </div>
      </div>
    </StatusContainer>
  );
}

StatusBar.propTypes = {
  status: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string
}
